import React from 'react';
import MainLayOut from '../layout/MainLayOut';

const Privacy = () => {
  return (
    <>
      <MainLayOut>
        {/* start */}
        <div className="max-w-5xl m-auto px-4 container py-10 leading-7 text-gray-700">

          <header className="text-center my-6">
            <h1 className="text-3xl font-bold">Privacy Policy</h1>
            <h2 className="text-xl font-semibold mt-2">Overview</h2>
          </header>

          <section className="space-y-6 text-justify">

            <h3 className="text-lg font-semibold">MPI Virgin Plastic – Privacy Policy</h3>
            <p><strong>Last updated:</strong> 20/10/2025</p>

            {/* 1. Introduction */}
            <section>
              <h3 className="text-lg font-semibold mt-6">1. Introduction</h3>
              <p>
                MPI Virgin Plastic (“we”, “us”, or “our”) respects your privacy. 
                This Privacy Policy explains how we collect, use, disclose, and protect 
                your personal data when you use our website and purchase our products.
              </p>
            </section>

            {/* 2. Data We Collect */}
            <section>
              <h3 className="text-lg font-semibold mt-6">2. Data We Collect</h3>
              <p>We may collect the following categories of data:</p>
              <ul className="list-disc ml-6">
                <li><strong>Identity Data:</strong> name, date of birth, gender.</li>
                <li><strong>Contact Data:</strong> email, phone number, address.</li>
                <li><strong>Transactional Data:</strong> order history, payment info (excluding sensitive card data).</li>
                <li><strong>Technical Data:</strong> IP address, browser type, device information.</li>
                <li><strong>Usage Data:</strong> pages visited, clicks, time spent, referring URLs.</li>
                <li><strong>Cookies & Tracking:</strong> cookies, beacons, analytics tools.</li>
              </ul>
            </section>

            {/* 3. Use of Data */}
            <section>
              <h3 className="text-lg font-semibold mt-6">3. Use of Your Data</h3>
              <ul className="list-disc ml-6">
                <li>Processing and fulfilling orders.</li>
                <li>Managing your account and providing customer support.</li>
                <li>Improving Website experience and performance.</li>
                <li>Sending marketing communications (if opted in).</li>
                <li>Complying with legal obligations.</li>
              </ul>
            </section>

            {/* 4. Legal Basis */}
            <section>
              <h3 className="text-lg font-semibold mt-6">4. Legal Basis for Processing (Under Indian Law)</h3>
              <ul className="list-disc ml-6">
                <li><strong>Consent:</strong> Provided when you register or place an order.</li>
                <li><strong>Performance of Contract:</strong> Required to fulfill your purchase.</li>
                <li><strong>Legal Obligations:</strong> Compliance with applicable laws.</li>
                <li><strong>Legitimate Interests:</strong> Security, analytics, fraud prevention.</li>
              </ul>
            </section>

            {/* 5. Data Retention */}
            <section>
              <h3 className="text-lg font-semibold mt-6">5. Data Retention</h3>
              <p>
                We retain personal data as long as necessary for legal, reporting, and business 
                purposes. In line with the Digital Personal Data Protection Act, 2023 (DPDP Act), 
                we may delete inactive user data after a mandated period. Users may also request deletion.
              </p>
            </section>

            {/* 6. Data Sharing */}
            <section>
              <h3 className="text-lg font-semibold mt-6">6. Data Sharing / Disclosure</h3>
              <ul className="list-disc ml-6">
                <li>Payment processors and gateways.</li>
                <li>Delivery and logistics partners.</li>
                <li>Legal/regulatory authorities if legally required.</li>
                <li>Affiliates/business partners (only with your consent when needed).</li>
              </ul>
            </section>

            {/* 7. Cookies */}
            <section>
              <h3 className="text-lg font-semibold mt-6">7. Cookies & Tracking Technologies</h3>
              <p>
                We use cookies to improve your experience, analyze usage, and show relevant content. 
                You may manage cookie preferences via your browser settings, though some functions 
                may be affected.
              </p>
            </section>

            {/* 8. Rights */}
            <section>
              <h3 className="text-lg font-semibold mt-6">8. Your Rights</h3>
              <ul className="list-disc ml-6">
                <li>Right to access your personal data.</li>
                <li>Right to correct/update inaccurate data.</li>
                <li>Right to request deletion (subject to legal limits).</li>
                <li>Right to withdraw consent at any time.</li>
                <li>Right to object to certain processing, including marketing.</li>
              </ul>
            </section>

            {/* 9. Security */}
            <section>
              <h3 className="text-lg font-semibold mt-6">9. Data Security</h3>
              <p>
                We use security measures such as encryption, secure servers, and access control. 
                However, no system is fully secure, and we cannot guarantee absolute protection.
              </p>
            </section>

            {/* 10. Breach */}
            <section>
              <h3 className="text-lg font-semibold mt-6">10. Data Breach</h3>
              <p>
                In case of a data breach, we will act promptly to mitigate the issue. 
                If required by law, affected users and relevant authorities will be notified.
              </p>
            </section>

            {/* 11. Cross-Border */}
            <section>
              <h3 className="text-lg font-semibold mt-6">11. Cross-Border Transfer</h3>
              <p>
                If personal data is transferred outside India, we ensure proper safeguards 
                and compliance with applicable legal requirements.
              </p>
            </section>

            {/* 12. Grievance */}
            <section>
              <h3 className="text-lg font-semibold mt-6">12. Grievance / Complaints</h3>
              <p>
                If you have concerns related to data handling, contact our Grievance Officer:
              </p>
              <p className="mt-2">
                <strong>Name:</strong> [Name] <br />
                <strong>Email:</strong> grievance-officer@example.com
              </p>
            </section>

            {/* 13. Children's Privacy */}
            <section>
              <h3 className="text-lg font-semibold mt-6">13. Children’s Privacy</h3>
              <p>
                Our Website is intended for adults (18+). We do not knowingly collect data from 
                minors without parental consent. If discovered, such data will be deleted.
              </p>
            </section>

            {/* 14. Changes */}
            <section>
              <h3 className="text-lg font-semibold mt-6">14. Changes to This Policy</h3>
              <p>
                We may revise this Privacy Policy periodically. The “Last updated” date will indicate changes. 
                Continued use of the Website means you accept the updated policy.
              </p>
            </section>

            {/* 15. Contact */}
            <section>
              <h3 className="text-lg font-semibold mt-6">15. Contact Us</h3>
              <p>
                <strong>MPI Virgin Plastic</strong><br />
                Siliguri, West Bengal, India<br />
                Email: mpislg21@gmail.com<br />
                Phone: 9733228888
              </p>
            </section>

          </section>

        </div>
        {/* end */}
      </MainLayOut>
    </>
  );
};

export default Privacy;
